module.exports = __webpack_public_path__ + "static/media/play.13fc6136.svg";